import React from 'react';
import c from '../w.js';

const IconFileVideo = React.memo(
  c(
    /* @__PURE__ */ React.createElement("path", { d: "M7 18.1316V5.86863C7 5.06993 7.89014 4.59354 8.5547 5.03657L17.7519 11.1681C18.3457 11.5639 18.3457 12.4363 17.7519 12.8322L8.5547 18.9636C7.89015 19.4067 7 18.9303 7 18.1316Z" })
  )
);

export { IconFileVideo };
